// LOGIN MODULE
export const LOGIN = 'LOGIN'

export const LOGOUT = 'LOGOUT'

export const PRE_PAGE = 'PRE_PAGE'

export const NEXT_PAGE = 'NEXT_PAGE'



// WEBPACK FOOTER //
// ./src/store/types.js